import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import { colors, TextField } from '@material-ui/core';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
// import LoadderButton from '../../Layouts/LoadderButton';
import AuthApi from '../../Services/Authapi';
// import Paper from '@material-ui/core/Paper';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
// import { SignalCellularNull } from '@material-ui/icons';
// import Authapi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
// import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
// import { now } from 'moment';
import moment from 'moment';
// import GridList from '@material-ui/core/GridList';
import { makeStyles } from '@material-ui/core/styles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import '../Leaves/Leave.css';

const useStyles = makeStyles((theme) => ({
    uploadArea: {
        width: '100%',
        minHeight: '100px',
        border: `2px dashed ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.2)' : '#cbd5e1'}`,
        borderRadius: '1rem',
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#f8fafc',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        padding: theme.spacing(1),
        color: theme.palette.type === 'dark' ? '#ffffff' : 'var(--hrms-primary-blue-end, #036dda)',
        '& .common-upload-drop-title': {
            color: theme.palette.type === 'dark' ? '#ffffff !important' : 'var(--hrms-primary-blue-end, #036dda) !important',
        },
        '& .common-upload-drop-caption': {
            color: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.82) !important' : 'var(--hrms-primary-blue-muted, #5b7a99) !important',
        },
        '& .common-upload-drop-button': {
            color: theme.palette.type === 'dark' ? '#ffffff !important' : 'var(--hrms-primary-blue-end, #036dda) !important',
            borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.6) !important' : 'var(--hrms-primary-blue-end, #036dda) !important',
        },
        '& .common-upload-drop-button .MuiButton-startIcon, & .common-upload-drop-button .MuiSvgIcon-root': {
            color: theme.palette.type === 'dark' ? '#ffffff !important' : 'var(--hrms-primary-blue-end, #036dda) !important',
        },
        '&:hover': {
            backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#f1f5f9',
            borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.4)' : '#94a3b8',
        },
    },
    uploadAreaActive: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.15)' : '#ffffff',
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 4px ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(30, 41, 59, 0.1)'}`,
    },
    fileInput: {
        display: 'none',
    },
}));


const iniEvent = {
    upcomingEventName: "",
    upcomingEventdate: "",
    description: "",
    image: null
}


const UpcomingEvent = (props) => {
    const classes = props;
    const styles = useStyles();

    const [eventValues, setEventsValues] = useState(iniEvent);
    // const [selectedImages, setSelectedImages] = useState({ image: null });
    // const [stringImages, setStringImages] = useState({ images: [] });
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [dragActive, setDragActive] = useState(false);


    useEffect(() => {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEventsValues({ ...eventValues, [name]: value });

        if (name === "upcomingEventdate") {
            const selectedDate = moment(value, "YYYY-MM-DD");
            const dayOfWeek = selectedDate.day();

            if (dayOfWeek === 6 || dayOfWeek === 0) { // 6 = Saturday, 0 = Sunday
                swal({
                    title: "Invalid Date",
                    text: "Weekends are not allowed",
                    icon: "error",
                });
            }
        }
    };


    const handleFileUpload = async (file) => {
        const postData = new FormData();
        postData.append('file', file);
        let updaImg = await AuthApi.uploadEventImg(postData);
        if (updaImg && updaImg.status === true) {
            setEventsValues({
                ...eventValues,
                image: updaImg.data.image_url,
                // imageName: updaImg.data.image_name
            })
        }
    }

    const uploadSingleFile = (e) => {
        if (e.target.files && e.target.files[0]) {
            handleFileUpload(e.target.files[0]);
        }
    }

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFileUpload(e.dataTransfer.files[0]);
        }
    };


    const removeImg = async (e) => {
        let imageLink = eventValues.image;
        imageLink = imageLink.substr(imageLink.indexOf('/', 7) + 1)
        let remImg = await AuthApi.upcomingdeleteImg(imageLink);
        if (remImg && remImg.status === true) {
            setEventsValues({
                ...eventValues,
                image: null,
                // imageName: null
            })
        }
    }


    // const removeImage = (e) => {
    //     const stringImages1 = stringImages.images
    //     const selectedImages1 = selectedImages
    //     stringImages1.splice(e, 1)
    //     selectedImages1.splice(e, 1)


    //     setSelectedImages((prevImages) => prevImages = selectedImages1)
    //     setStringImages({ ...stringImages, images: stringImages1 });
    // }

    function dateDiffInDays(startDate, endDate) {
        return Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));
    }
    const dsp = dateDiffInDays(new Date(), new Date(eventValues.upcomingEventdate))


    const validate = (values) => {
        let errors = {};
        const regex = /^[a-zA-Z]/;
        const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

        if (!values.upcomingEventName) {
            errors.upcomingEventName = "Cannot be blank";
        } else if (!regex.test(values.upcomingEventName)) {
            errors.upcomingEventName = "Invalid upcomingEventName format";
        }

        if (!values.upcomingEventdate) {
            errors.upcomingEventdate = "Cannot be blank";
        } else if (!dateR.test(values.upcomingEventdate)) {
            errors.upcomingEventdate = "Invalid upcomingEventdate format";
        } else {
            const selectedDate = moment(values.upcomingEventdate, "YYYY-MM-DD");
            const dayOfWeek = selectedDate.day();
            if (dayOfWeek === 6 || dayOfWeek === 0) {
                errors.upcomingEventdate = "Weekends are not allowed";
            }
        }

        if (!values.description) {
            errors.description = "Cannot be blank";
        } else if (!regex.test(values.description)) {
            errors.description = "Invalid description format";
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validate(eventValues);
        setFormErrors(errors);

        if (Object.keys(errors).length === 0) {
            setIsSubmitting(true);
        } else if (errors.upcomingEventdate) {
            swal({
                title: "Invalid Date",
                text: errors.upcomingEventdate,
                icon: "error",
            });
        }
    };

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmitting) {
            upcomingEvent();
        }
    }, [formErrors])


    const upcomingEvent = async () => {
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            icon: "info",
        });
        try {
            let create1 = await AuthApi.createUpcomingEvent(eventValues);
            swal.close();
            if (create1 && create1.status === true) {
                swal("Success", "Event added successfully", "success").then(() => {
                    props.history.push('/upcoming-event');
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: create1 && create1.message ? create1.message : "Something went wrong, Please try later!"
                })
            }
        } catch (error) {
            console.error("Error updating upcoming:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    }


    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <div className="holiday-breadcrumb-card">
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="Upcoming Events"
                                    primaryPageLink="/upcoming-event"
                                    isSecondaryPage={true}
                                    secondaryPageName="Add Upcoming Event" />
                        </div>
                        <div className="holiday-form-card">
                            <Typography variant="h2" className="holiday-form-title" style={{ color: '#036dda', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Add Upcoming Event</Typography>
                            <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit} >
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="upcomingEventName"
                                                        name="upcomingEventName"
                                                        label="Event Name"
                                                        variant="outlined"
                                                        error={formErrors.upcomingEventName && true}
                                                        value={eventValues.upcomingEventName}
                                                        onChange={handleChange}
                                                        className={formErrors.upcomingEventName && "input-error"}

                                                    />
                                                    {formErrors.upcomingEventName && (
                                                        <span className="error">{formErrors.upcomingEventName}</span>
                                                    )}
                                                </Grid>


                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="date"
                                                        variant="outlined"
                                                        label="Event Date"
                                                        name="upcomingEventdate"
                                                        type="date"
                                                        error={formErrors.upcomingEventdate && true}
                                                        value={eventValues.upcomingEventdate}
                                                        onChange={handleChange}
                                                        className={`${formErrors.upcomingEventdate && "input-error"} ${classes.textField}`}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        inputProps={{
                                                            min: moment().add(1, 'days').format('YYYY-MM-DD')
                                                        }}
                                                    />
                                                    {formErrors.upcomingEventdate && (
                                                        <span className="error">{formErrors.upcomingEventdate}</span>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        rows={3}
                                                        variant="outlined"
                                                        label="Event Details"
                                                        name="description"
                                                        error={formErrors.description && true}
                                                        value={eventValues.description}
                                                        onChange={handleChange}
                                                        className={formErrors.description && "input-error"}
                                                    />
                                                    {formErrors.description && (
                                                        <span className="error">{formErrors.description}</span>
                                                    )}
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <div
                                                        className={`${styles.uploadArea} ${dragActive ? styles.uploadAreaActive : ''}`}
                                                        onDragEnter={handleDrag}
                                                        onDragLeave={handleDrag}
                                                        onDragOver={handleDrag}
                                                        onDrop={handleDrop}
                                                        onClick={() => document.getElementById('contained-button-file').click()}
                                                    >
                                                        <input
                                                            accept="image/*"
                                                            className={styles.fileInput}
                                                            id="contained-button-file"
                                                            type="file"
                                                            onChange={uploadSingleFile}
                                                        />
                                                        {eventValues.image && (
                                                            <img
                                                                src={eventValues.image}
                                                                alt="Event image"
                                                                style={{
                                                                    width: "100px",
                                                                    height: "100px",
                                                                    marginBottom: '8px',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                                                                }}
                                                            />
                                                        )}
                                                        <Typography variant="subtitle2" className="common-upload-drop-title">
                                                            {eventValues.image ? "Change File" : "Drag & Drop your file here"}
                                                        </Typography>
                                                        <Typography variant="caption" className="common-upload-drop-caption">
                                                            or
                                                        </Typography>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            component="span"
                                                            size="small"
                                                            startIcon={<CloudUploadIcon />}
                                                            className="common-upload-drop-button"
                                                        >
                                                            Upload a file
                                                        </Button>
                                                    </div>
                                                    {eventValues.image && (
                                                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                                            <Button onClick={(e) => removeImg(e)} size="small" color="secondary">
                                                                Remove Image
                                                            </Button>
                                                        </div>
                                                    )}
                                                </Grid>



                                            </Grid>

                                            {/* <Grid container className={classes.root} spacing={5} >
                                                <Grid item xs={6}>
                                                    <div style={{ float: "left" }}>
                                                        <Card className={classes.root}>
                                                            <Grid item xs={12}>
                                                                <div>
                                                                    <img src={eventValues.image} alt="Event image" width="100" height="100" />
                                                                </div>
                                                            </Grid>
                                                        </Card>
                                                    </div>
                                                </Grid>
                                            </Grid> */}



                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={4} style={{ display: 'flex' }}>
                                                    <Button type="submit" className="btn-success" variant="contained" style={{ marginTop: "10px", textTransform: 'none' }} color="primary">Save</Button>
                                                    <Button type="button" className="btn-cancel" style={{ marginTop: "10px", textTransform: 'none' }} onClick={(e) => { e.preventDefault(); props.history.push('/upcoming-event') }}>Cancel</Button>
                                                </Grid>
                                                <Grid item xs={4}></Grid>
                                                <Grid item xs={4}></Grid>
                                            </Grid>
                                        </form>
                        </div>
                    </div>
                } />
            <Footer />
        </div>
    )

}

export default UpcomingEvent;


